<mat-card>
  <mat-card-header>
    <mat-card-title>{{addTagTitle | translate}}</mat-card-title>
  </mat-card-header>
  <mat-card-content style="padding-top: 20px">
    <mat-form-field style="width: 100%">
      <mat-chip-listbox #chipList>
        @for (tag of tags; track tag) {
          <mat-chip [removable]="true" (removed)="removeTag(tag)">
            {{tag}}
            <mat-icon class="notranslate" matChipRemove>cancel</mat-icon>
          </mat-chip>
        }
        <input matInput placeholder="{{addTagTooltip | translate}}" (keydown.enter)="addTag(input)" #input>
      </mat-chip-listbox>
    </mat-form-field>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-raised-button color="primary" (click)="closeModal()">{{close | translate}}</button>
  </mat-card-actions>
</mat-card>
